import React from "react";
import { Modal, Button } from "antd";

// Inactivity warning with countdown (antd Modal — themed by the app's
// ConfigProvider). Mask is non-dismissable: the page (and any form the user
// was filling) stays visible and intact behind it — no reload, no route
// change; leaving requires an explicit button.

const formatCountdown = (totalSec: number): string => {
  const m = Math.floor(Math.max(0, totalSec) / 60);
  const s = Math.max(0, totalSec) % 60;
  return `${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`;
};

interface SessionExpiryModalProps {
  isOpen: boolean;
  remainingSec: number;
  busy: boolean;
  onStayLoggedIn: () => void;
  onSignOut: () => void;
}

const SessionExpiryModal: React.FC<SessionExpiryModalProps> = ({
  isOpen,
  remainingSec,
  busy,
  onStayLoggedIn,
  onSignOut,
}) => (
  <Modal
    open={isOpen}
    closable={false}
    maskClosable={false}
    keyboard={false}
    footer={null}
    centered
    width={400}
    // Must always sit above the app header/drawers/toasts.
    zIndex={10000}
  >
    <div style={{ textAlign: "center", padding: "8px 0 4px" }}>
      <h4 style={{ marginBottom: 8, fontWeight: 700 }}>Session Expiring</h4>
      <p style={{ marginBottom: 8 }}>
        Your session is about to expire due to inactivity.
      </p>
      <div
        data-testid="session-countdown"
        style={{
          fontSize: 32,
          fontWeight: 700,
          fontVariantNumeric: "tabular-nums",
          marginBottom: 16,
        }}
      >
        {formatCountdown(remainingSec)}
      </div>
      <div style={{ display: "flex", justifyContent: "center", gap: 12 }}>
        <Button type="primary" loading={busy} onClick={onStayLoggedIn}>
          Stay Logged In
        </Button>
        <Button disabled={busy} onClick={onSignOut}>
          Sign Out
        </Button>
      </div>
    </div>
  </Modal>
);

export default SessionExpiryModal;
